import { LeagueParticipant } from '../models';
import { LeagueRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class AddLeagueParticipantUseCase {
  constructor(
    private leagueRepository: LeagueRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(params: {
    leagueId: string;
    name: string;
    userId?: string;
    actionUserId?: string;
  }): Promise<LeagueParticipant> {
    const { leagueId, name, userId, actionUserId } = params;

    if (!name.trim()) {
      throw new Error('Participant name is required');
    }

    // Moderate content before writing
    const moderationUserId = actionUserId || userId;
    if (moderationUserId) {
      await this.moderateContent.execute(name, 'participant_name', moderationUserId);
    }

    const league = await this.leagueRepository.getById(leagueId);
    if (!league) {
      throw new Error('League not found');
    }

    return await this.leagueRepository.addParticipant({
      leagueId,
      name: name.trim(),
      userId,
    });
  }
}
